export default __webpack_public_path__ + "static/media/016_photo.40fc1eb6.jpg";